import { Box, chakra } from '@chakra-ui/react'

export const DashboardCard = chakra(Box, {
  baseStyle: {
    minH: 40,
    color: 'fg',
    bg: 'neutralAlpha.100',
    borderRadius: 'lg',
    p: 4,
    boxShadow: 'base'
  }
})
